import React, { useCallback, useState } from "react";
import { Alert, Container, Typography } from "@mui/material";
import LoginForm from "../components/Login/LoginForm";
import { ServerDownView } from "../components/Login/ServerDownView";
import { checkServerHealth } from "../core/serverHealth";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuthStore } from "../stores/authStore";

const LoginPage: React.FC = () => {
  const setAuthenticated = useAuthStore((state) => state.setAuthenticated);
  const redirectPath = useAuthStore((state) => state.redirectPath);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [serverDown, setServerDown] = useState(false);
  const [reconnectMessage, setReconnectMessage] = useState<string | null>(null);
  // מופעל רק אחרי לחיצה על Login שנכשלה בגלל שהשרת לא זמין — כשהוא חוזר שולחים שוב אוטומטית
  const [resubmitSignal, setResubmitSignal] = useState(0);

  const handleLoginSuccess = () => {
    // בדיקה אם יש returnUrl בquery params (מ-auto logout)
    const returnUrl = searchParams.get("returnUrl");
    const targetPath = returnUrl || redirectPath || "/";
    navigate(targetPath); // חזרה לדף הקודם או לדף הבית
  };

  const handleServerDown = useCallback(() => {
    setReconnectMessage(null);
    setServerDown(true);
  }, []);

  const retryConnection = useCallback(async () => {
    if (await checkServerHealth()) {
      setServerDown(false);
      setReconnectMessage("החיבור לשרת חזר — מתחבר...");
      setResubmitSignal((n) => n + 1);
    }
  }, []);

  console.log("LOGIN PAGE API URL:", process.env.REACT_APP_API_URL);
  console.log("LOGIN PAGE NODE_ENV:", process.env.NODE_ENV);

  return (
    <Container maxWidth="xs">
      <Typography variant="h4" align="center" gutterBottom>
        Rev&U Login
      </Typography>

      <LoginForm
        onSuccess={handleLoginSuccess}
        onServerDown={handleServerDown}
        onLoginFailed={() => setReconnectMessage(null)}
        resubmitSignal={resubmitSignal}
      />

      {reconnectMessage && !serverDown && (
        <Alert severity="success" dir="rtl" sx={{ mt: 2 }} onClose={() => setReconnectMessage(null)}>
          {reconnectMessage}
        </Alert>
      )}

      {serverDown && <ServerDownView onRetry={retryConnection} />}
    </Container>
  );
};

export default LoginPage;
